import { useState } from 'react';
import update from 'immutability-helper';

const useSarasCalendarDnDManager = (dndType, defaultSortMode) => {
    const [sortMode, setSortMode] = useState(defaultSortMode === undefined ? true : defaultSortMode);

    const onToggleSort = () => {
        setSortMode(!sortMode);
    };

    const isSortMode = () => {
        return sortMode;
    };

    const groupKeys = (groupData) => {
        return groupData ? groupData.ViewRowsKeys : [];
    };

    const getGroupRow = (groupRow, rowIndex) => {
        return groupRow.rowValues.matchedData.childRows[rowIndex];
    };

    const getGroupRowsKeys = (groupRow) => {
        if (groupRow) {
            return groupRow.rowValues.matchedData.ChildRowsKeys;
        }

        return [];
    };

    const onDragEnd = (groupData, result) => {
        if (!result || !result.source || !result.destination) return null;

        const newGroupData = { ...groupData };

        const sourceGroup = newGroupData.viewRows[result.source.droppableId];
        const destGroup = newGroupData.viewRows[result.destination.droppableId];
        if (!sourceGroup || !destGroup) return null;

        const sourceWeekKey = sourceGroup.rowValues.weekKey.val;
        const destWeekKey = destGroup.rowValues.weekKey.val;
        const isGroupChanged = result.source.droppableId !== result.destination.droppableId;

        const sourceKey = sourceGroup.rowValues.matchedData.ChildRowsKeys[result.source.index];
        const sourceRow = sourceGroup.rowValues.matchedData.childRows[sourceKey];
        if (!sourceKey || !sourceRow) return null;

        if (!isGroupChanged) {
            destGroup.rowValues.matchedData.ChildRowsKeys = update(destGroup.rowValues.matchedData.ChildRowsKeys, {
                $splice: [
                    [result.source.index, 1],
                    [result.destination.index, 0, sourceKey],
                ],
            });
        }
        else {
            destGroup.rowValues.matchedData.childRows[sourceKey] = sourceRow;

            sourceGroup.rowValues.matchedData.ChildRowsKeys = update(sourceGroup.rowValues.matchedData.ChildRowsKeys, {
                $splice: [
                    [result.source.index, 1],
                ],
            });

            destGroup.rowValues.matchedData.ChildRowsKeys = update(destGroup.rowValues.matchedData.ChildRowsKeys, {
                $splice: [
                    [result.destination.index, 0, sourceKey],
                ],
            });
        }

        const changedStartIndex = isGroupChanged
            ? result.destination.index
            : Math.min(result.source.index, result.destination.index);
        const destRowKeys = [...destGroup.rowValues.matchedData.ChildRowsKeys];
        const destRows = destRowKeys.map((rowKey) => destGroup.rowValues.matchedData.childRows[rowKey]);
        const changedDestRows = destRowKeys.slice(changedStartIndex).map((rowKey) => destGroup.rowValues.matchedData.childRows[rowKey]);

        let previousIndex = -1;
        let previousKey = null;
        let previousRow = null;

        if (result.destination.index > 0) {
            previousIndex = result.destination.index - 1;
        }

        if (previousIndex >= 0) {
            previousKey = destGroup.rowValues.matchedData.ChildRowsKeys[previousIndex];

            if (previousKey) previousRow = destGroup.rowValues.matchedData.childRows[previousKey];
        }

        return {
            groupData: newGroupData,
            sourceRow: {
                groupKey: sourceWeekKey,
                newGroupKey: destWeekKey,
                weekKey: sourceWeekKey,
                newWeekKey: destWeekKey,
                docId: sourceRow.did,
                docTypeId: sourceRow.dtid,
                rowKey: sourceKey,
                sourceIndex: result.source.index,
                destinationIndex: result.destination.index,
                isGroupChanged
            },
            destGroup: {
                groupKey: destWeekKey,
                rowKeys: destRowKeys,
                rows: destRows,
                changedStartIndex,
                changedRows: changedDestRows
            },
            previousRow: {
                docId: previousRow ? previousRow.did : 0
            }
        };
    };

    return {
        onToggleSort,
        isSortMode,
        onDragEnd,
        groupKeys,
        getGroupRowsKeys,
        getGroupRow,
        dndType
    };
};

export default useSarasCalendarDnDManager;
